var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var ERROR_STYLE = "text-xs text-white font-body bg-red-600 rounded absolute top-100 right-0 mt-1 whitespace-nowrap px-1 z-10";
export var Error = function (_a) {
    var children = _a.children;
    return (_jsx("span", __assign({ className: ERROR_STYLE }, { children: children }), void 0));
};
